import { ZAttrMeta } from "src/business/attribute";
import { AttrVisitor } from "src/business/attribute/AttrVisitor";
import { walkAttr } from "src/business/attribute/AttrVisitor/walkAttr";

/**
 * Убрать из всех атрибутов временные уиды, которые использовались для вновь созданных атрибутов.
 * Временные уиды начинаются с символа "@".
 * Они могут быть как в верхних атрибутах, так и во вложенных.
 * @param attrList список атрибутов. IN/OUT (структуры мутируют)
 */
export const clearTmpUids = (attrList: ZAttrMeta[] | null | undefined) => {
  const visitor: AttrVisitor = {
    onEach(attr) {
      // eslint-disable-next-line no-param-reassign
      if (attr.uid[0] === "@") attr.uid = "";
    },
  };
  attrList?.forEach((attr) => walkAttr(attr, visitor, {}));
};
